import { Input as BaseInput, InputGroup } from "@mozioinc/ui";
import { Label } from "./label";
import type { FC, InputHTMLAttributes } from "react";

interface InputComponentProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  placeholder?: string;
  rightContent?: React.ReactNode;
}

export const Input: FC<InputComponentProps> = ({ label, ...props }) => {
  return (
    <div className="flex flex-col">
      <Label htmlFor={props.id || props.name}>{label}</Label>
      <InputGroup className="relative rounded-t-none p-0">
        <BaseInput
          className="rounded-b rounded-t-none bg-white px-2 pl-3 pr-10 text-left text-sm text-slate-700"
          placeholder={props.placeholder}
          onBlur={props.onBlur}
        />
        {props.rightContent}
      </InputGroup>
    </div>
  );
};
